import { useEffect } from 'react';

import { transformOriginalImageUrl } from 'common/utils/cdn/image';
import { saveRecentSearch } from 'common/utils/recent-searches';
import type { ProductListViewProps } from '../components/types';

type UseStoreRecentSearchParams = Pick<
  ProductListViewProps,
  'storeSearch' | 'query' | 'firstImage'
>;

const THUMBNAIL_SIZE = 90;

export const useSaveRecentSearch = ({
  storeSearch,
  query,
  firstImage,
}: UseStoreRecentSearchParams) => {
  useEffect(() => {
    if (!storeSearch || !query) {
      return;
    }

    saveRecentSearch({
      keyword: query.trim(),
      ...(firstImage && {
        thumbnail: transformOriginalImageUrl(firstImage, {
          width: THUMBNAIL_SIZE,
        }),
      }),
    });
  }, []);
};
